/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import Select from "react-select";

const AddDistributorSubuser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: id || "",
    allot_user: [],
    activate: true,
  });
  const [userData, setUserData] = useState({
    user_fullname: "",
    user_role: "",
  });
  const [subuserList, setSubuserList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (id) {
          const response = await axios.get(
            `${API_URL}distributor-user/add-team-user/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                accept: "*/*",
              },
            }
          );

          if (response.data) {
            const { user, subuserlist, userdata } = response.data;

            if (user) {
              setUserData({
                user_fullname: user.t1_user_fullname || "",
                user_role: user.t2_user_role || "",
              });
            }

            if (subuserlist && subuserlist.length > 0) {
              setSubuserList(subuserlist);
            }

            if (userdata && userdata.length > 0) {
              const allocatedUserIds = userdata.map((uid) => uid.toString());
              setFormData((prev) => ({
                ...prev,
                allot_user: allocatedUserIds,
              }));

              const selectedOpts = (subuserlist || [])
                .filter((u) => allocatedUserIds.includes(u.t1_id.toString()))
                .map((u) => ({
                  value: u.t1_id.toString(),
                  label: u.t1_user_fullname,
                }));
              setSelectedOptions(selectedOpts);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching subuser data:", error);
        showToast.error("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, token]);

  const handleMultiSelectChange = (options) => {
    setSelectedOptions(options || []);
    const selectedIds = options ? options.map((opt) => opt.value.toString()) : [];
    setFormData((prev) => ({
      ...prev,
      allot_user: selectedIds,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const payload = {
        id: Number(formData.id),
        allot_user: formData.allot_user.map(Number),
        activate: formData.activate ? 1 : 0,
      };

      const response = await axios.post(
        `${API_URL}distributor-user/save-subuser`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            accept: "*/*",
          },
        }
      );

      if (response.data.success) {
        showToast.success(response.data.message || "Subusers saved successfully");
        navigate("/Hrms/DistributorUser");
      } else {
        showToast.error(response.data.message || "Failed to save subusers");
      }
    } catch (error) {
      console.error("Error saving subusers:", error);
      showToast.error(
        error.response?.data?.message || "An error occurred while saving subusers"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-3">
      <div className="row mb-3">
        <div className="col-md-6">
          <h4 className="user-management-title">Assign Subusers (Distributor)</h4>
        </div>
        <div className="col-md-6 text-end">
          <Link to="/Hrms/DistributorUser" className="btn btn-secondary btn-sm">
            Back to List
          </Link>
        </div>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="bg-white p-4 rounded shadow-sm">
          <div className="mb-4">
            <h5>
              Manager: <strong>{userData.user_fullname}</strong> ({userData.user_role})
            </h5>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label className="form-label">Select Subusers to Assign:</label>
              <Select
                isMulti
                name="allot_user"
                options={subuserList.map((u) => ({
                  value: u.t1_id.toString(),
                  label: u.t1_user_fullname,
                }))}
                value={selectedOptions}
                onChange={handleMultiSelectChange}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Search and select subusers..."
              />
            </div>

            <div className="mt-4 pt-3 border-top d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-outline-secondary me-2"
                onClick={() => navigate("/Hrms/DistributorUser")}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Saving..." : "Save Subuser Assignment"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default AddDistributorSubuser;
